export default __webpack_public_path__ + "static/insights-89a1c57a3edd04c6f8cdebd6404b0d3d.png";